<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="商户号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入商户号查询" v-model="queryParam.mchNo"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div style="margin-bottom: 15px" v-if="btnEnableList.indexOf(1)>-1">
          <a-button type="primary" icon="plus" @click="handleAdd">配置商户号</a-button>
          <a-button v-if="!applyBlocked" type="primary" icon="safety-certificate" style="margin-left: 8px" @click="applyVisible = true">商户进件</a-button>
          <a-tag v-if="applyBlocked" color="orange" style="margin-left: 8px">收款由总店统一代收，无需进件</a-tag>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="status" slot-scope="text">
              <a-tag v-if="text === '1'" color="green">启用</a-tag>
              <a-tag v-else color="red">停用</a-tag>
            </template>
            <span slot="action" slot-scope="text, record">
              <template v-if="btnEnableList.indexOf(1)>-1">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm title="删除后该租户将无法在线收款，确定删除吗?" @confirm="() => handleDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
      </a-card>

      <!-- 商户进件 Modal（微信特约商户在线进件，成功自动回填商户号） -->
      <mch-apply-modal :visible.sync="applyVisible" @close="loadData" />

      <!-- 手动配置商户号 Modal -->
      <a-modal
        :title="form.id ? '编辑商户号' : '配置商户号'"
        :visible="modalVisible"
        :confirmLoading="saving"
        @ok="handleSave"
        @cancel="modalVisible = false">
        <a-form>
          <a-form-item v-if="isSuperAdmin && !form.id" label="租户ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-model="form.tenantId" :min="1" style="width: 100%" placeholder="请输入租户ID" />
          </a-form-item>
          <a-form-item v-else label="租户ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <span>{{ form.tenantId }}</span>
          </a-form-item>
          <a-form-item v-if="!form.id" label="渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-model="form.channel" style="width: 160px">
              <a-select-option value="WX">微信</a-select-option>
              <a-select-option value="ALI">支付宝</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-else label="渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <span>{{ form.channel === 'ALI' ? '支付宝' : '微信' }}</span>
          </a-form-item>
          <a-form-item label="商户号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="form.mchNo" placeholder="请输入Jeepay商户号" :maxLength="64" />
          </a-form-item>
          <a-form-item v-if="form.id" label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-model="form.status" style="width: 120px">
              <a-select-option value="1">启用</a-select-option>
              <a-select-option value="0">停用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea v-model="form.remark" :rows="2" placeholder="备注信息（选填）" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getPayMerchants, addPayMerchant, updatePayMerchant, deletePayMerchant, getMchApplyCurrent } from '@/api/plugin/orderReceive'
import { getAction } from '@/api/manage'
import Vue from 'vue'
import { USER_INFO } from '@/store/mutation-types'
import MchApplyModal from './MchApplyModal'

export default {
  name: 'PayMerchantList',
  mixins: [JeecgListMixin],
  components: { MchApplyModal },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      urlPath: '/plugin/order-receive/paymerchant',
      queryParam: {
        mchNo: ''
      },
      modalVisible: false,
      applyVisible: false,
      applyBlocked: false, // 进件收口：门店租户未开收款时隐藏进件入口
      saving: false,
      form: {},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '租户ID',
          dataIndex: 'tenantId',
          width: 100,
          align: 'center'
        },
        {
          title: '渠道',
          dataIndex: 'channel',
          width: 90,
          align: 'center',
          customRender: function(text) {
            return text === 'ALI' ? '支付宝' : '微信'
          }
        },
        {
          title: '商户号',
          dataIndex: 'mchNo',
          width: 220
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 180
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 130,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/pay-merchants'
      }
    }
  },
  computed: {
    isSuperAdmin() {
      return this.currentTenantId() === 0
    }
  },
  created() {
    // 静默刷新进件进度（后端实时查微信状态，成功自动回填商户号并写站内通知；失败忽略）
    getMchApplyCurrent().catch(() => {})
    // 进件收口（decentralize-store-pay B）：门店租户未开收款隐藏进件入口（接口失败按不隐藏处理）
    getAction('/api/plugin/dining/store-context').then((res) => {
      if (res.code === 200 && res.data) {
        this.applyBlocked = !!res.data.isStore && String(res.data.allowPay) !== '1'
      }
    }).catch(() => {})
  },
  methods: {
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        mchNo: this.queryParam.mchNo
      }
    },
    handleAdd() {
      this.form = { tenantId: this.isSuperAdmin ? undefined : this.currentTenantId(), channel: 'WX', mchNo: '', status: '1', remark: '' }
      this.modalVisible = true
    },
    handleEdit(record) {
      this.form = Object.assign({}, record)
      this.modalVisible = true
    },
    handleSave() {
      if (!this.form.mchNo || !this.form.mchNo.trim()) {
        this.$message.warning('请输入商户号')
        return
      }
      if (!this.form.id && !this.form.tenantId) {
        this.$message.warning('请输入租户ID')
        return
      }
      this.saving = true
      const req = this.form.id
        ? updatePayMerchant(this.form.id, { mchNo: this.form.mchNo, status: this.form.status, remark: this.form.remark })
        : addPayMerchant({ tenantId: this.form.tenantId, channel: this.form.channel, mchNo: this.form.mchNo, remark: this.form.remark })
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.modalVisible = false
          this.loadData()
        } else {
          this.$message.warning(res.message || '保存失败')
        }
      }).finally(() => {
        this.saving = false
      })
    },
    handleDelete(record) {
      deletePayMerchant(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    currentTenantId() {
      const stored = Vue.ls.get(USER_INFO)
      if (!stored) return undefined
      const userInfo = typeof stored === 'string' ? JSON.parse(stored) : stored
      const value = userInfo.value ? userInfo.value : userInfo
      return value ? value.tenantId : undefined
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
</style>
